import { EnumOption } from "./enum-option"

export const TaskPriority = {
  Low : 0,
  Normal: 1,
  High: 2,
}

export const TaskPriorityList: EnumOption[] = [
    { value: TaskPriority.Low, label: 'Low' },
    { value: TaskPriority.Normal, label: 'Normal' },
    { value: TaskPriority.High, label: 'High' },
]
